import React, { memo, useMemo } from 'react';
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import { Trash,PenIcon } from "lucide-react";
import { Link } from "react-router-dom";

const AdminGalleryView = ({ galleryList, handleDelete, toggleStatus, loading }) => {
    const renderedGallery = useMemo(() => {
        return (
            <>
                {Array.isArray(galleryList) && galleryList.length > 0 ? (
                    <div className="flex flex-wrap mt-8">
                        {galleryList.map((data, index) => (
                            <div className="space-y-4  w-[32.33%] mr-3 mb-3 ">
                                <div className="bg-white rounded-2xl p-6 border-gray-200 border shadow-sm custom-theme-scroll">
                                    <div className="flex item-center justify-between">

                                        <span className=" text-lg mb-4">
                                            <span className="font-extrabold">Image :</span>
                                            <span className="font-medium"> {index + 1} </span>
                                        </span>
                                        {data.id ?
                                            
                                            <>
                                                <span className='flex items-center mt-2'>
                                                    <Link to={`/media-gallery/${data.id}`}>
                                                        <PenIcon className='w-6 h-6 cursor-pointer hover:bg-green-100 p-1 transition duration-300 ease-in-out' />
                                                    </Link>
                                                    <Trash onClick={() => handleDelete(data.id)} className='w-6 h-6 cursor-pointer rounded-full hover:bg-red-100 p-1 transition duration-300 ease-in-out' />
                                                </span>
                                            </> : ''
                                        }
                                    </div>
                                    <div className="">
                                        <div className="  slider-image-wrapper ">
                                            <LightGallery
                                                licenseKey={data.id}
                                                plugins={[lgZoom, lgVideo]}
                                                mode="lg-fade"
                                                pager={false}
                                                thumbnail={true}
                                                galleryId={'nature'}
                                                autoplayFirstVideo={false}
                                                elementClassNames={'gallery'}
                                                mobileSettings={{
                                                    controls: false,
                                                    showCloseIcon: false,
                                                    download: false,
                                                    rotate: false,
                                                }}
                                            >
                                                <a
                                                    data-lg-size="1600-1144"
                                                    data-pinterest-text="Pin it3"
                                                    data-tweet-text="lightGallery slide  4"
                                                    className="gallery__item"
                                                    data-src={`${data.path}`}
                                                // data-sub-html="<h4>Photo by - <a href='https://unsplash.com/@aaronburden' >Aaron Burden</a></h4><p>Location - <a href='https://unsplash.com/s/photos/grayling%2C-michigan%2C-united-states'>Grayling, Michigan, United States</a> Colorful trees near a lake. <a href='https://unsplash.com/photos/00QWN1J0g48'>Link</a> </p>"
                                                >
                                                    <img
                                                        className="img-responsive slider-image mx-auto"
                                                        src={`${data.path}`}
                                                    />
                                                </a>
                                            </LightGallery>
                                        </div>

                                        <div className="slider-image-detail pt-2.5 px-2.5 items-baseline">
                                            <div className="text-justify leading-5">
                                                <span className="text-sm text-lg mr-4">
                                                    <strong>Title:</strong> {data.title}
                                                    <br />
                                                    <div className="flex items-center mt-2">
                                                        <span className="text-sm font-semibold mr-2">Status:</span>
                                                        <div className="relative flex items-center">
                                                            <div
                                                                className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-all duration-300 ${data.status ? "bg-green-500" : "bg-gray-300"
                                                                    }`}
                                                                onClick={loading ? null : () => toggleStatus(data.id)}
                                                            >
                                                                <div
                                                                    className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-all duration-300 ${data.status ? "translate-x-6" : "translate-x-0"
                                                                        }`}
                                                                ></div>
                                                            </div>
                                                            {loading && <span className="ml-2 text-sm text-gray-500">Updating...</span>}
                                                        </div>
                                                    </div>
                                                    <strong>Description:</strong> {data.description}
                                                    <br />
                                                </span>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    null
                )}
            </>
        );
    }, [galleryList]);

    return renderedGallery;
}

export default memo(AdminGalleryView);

